import { rgbToHex } from '@mui/material'
import { useState } from 'react'
import { ColorResult, SketchPicker } from 'react-color'

interface CustomColorPickerProps {
  value?: string
  onChange?: (color?: string) => void
}

export const CustomColorPicker = (props: CustomColorPickerProps) => {
  const { value, onChange } = props

  const [color, setColor] = useState<ColorResult>()

  const handleChange = (color: ColorResult) => {
    setColor(color)
    const rgbColorString = `rgba(${color?.rgb?.r}, ${color?.rgb?.g}, ${color?.rgb?.b}, ${color?.rgb?.a})`

    const hex = color?.rgb ? rgbToHex(rgbColorString) : undefined
    onChange?.(hex)
  }

  return (
    <SketchPicker
      color={color?.rgb || value}
      onChange={handleChange}
      presetColors={[]}
    />
  )
}
